{
  "Earlier": "更早",
  "noAnnouncements": "您将收到有关计划的维护活动和修复的产品问题的信息。",
  "noAnnouncementsTitle": "将在此处显示您的通告"
}
